import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 26px;
  margin-bottom: 30px;
  @media (max-width: 580px) {
    flex-direction: column;
  }
`;

const Description = styled.div`
  flex: 1;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  padding: 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  @media (max-width: 580px) {
    width: 100%;
  }
  p {
    margin: 0 0 16px;
  }
`;

export const DescWhatIs = styled(Description)`
  background: #fff;
  color: ${({ theme }) => theme.colors.mainDark};
  & .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 18px;
  }
`;

export const DescWhatIsnt = styled(Description)`
  background: ${({ theme }) => theme.colors.mainDark};
  color: #fff;
  & .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 18px;
  }
`;
